<template>
  <div class="beefCont">
    <img src="../assets/imgs/98/bg.jpg" class="bg" alt="" />
    <Qrcode :pic="98" />
    <div class="phoneCommon">
        咨询电话：<a href="tel:028-61647545" style="color:#fff">028-61647545</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";
.beefCont {
  width: 100vw;
  position: relative;
  .bg {
    width: 100%;
    height: 111.2rem;
    display: block;
  }
}
</style>